import styled from 'styled-components';

export const RDBanner = styled.div`
  padding: 15px 20px;
  border-radius: 8px;
  margin-top: 20px;
  background-color: #e3fff4;
  display: flex;
  align-items: center;
  .textBlock {
    margin-left: 20px;
    font-size: 14px;
    display: flex;
    flex-direction: column;
    .bold {
      font-weight: bold;
    }
  }
`;

export const RDContainer = styled.div`
  display: grid;
  gap: 24px;
  grid-template-columns: repeat(3, minmax(250px, calc((100% - 24px) / 3)));
  @media (max-width: 1060px) {
    grid-template-columns: repeat(2, minmax(250px, calc((100% - 24px) / 2)));
  }
  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
  align-items: stretch;
  &.mTop40 {
    margin-top: 40px;
  }
`;

export const RDBlock = styled.div`
  padding: 18px 0 0 16px;
  background-color: #ffffff;
  border-radius: 10px;
  position: relative;
  box-shadow: 0 8px 16px 0 #dddddd52;
  display: flex;
`;

export const RDBlockLeft = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1 1 auto;
  // margin-right: 100px;
  @media (max-width: 550px) {
    // margin-right: 40px;
  }

  &.textOverlap {
    margin-right: -100px;
    z-index: 2;
    position: relative;
  }

  .description {
    font-size: 12px;
    margin-top: 6px;
  }
  .advice {
    margin-top: 0;
    color: #929cb9;
    font-size: 8px;
    font-style: italic;
  }
  .visual {
    margin-top: 16px;
    font-size: 10px;
  }
  .advice + .visual {
    margin-top: 0;
  }
`;

export const RDBlockRight = styled.div`
  //max-width: 130px;
  //min-width: 100px;
  //width: 22.5%;
  //display: flex;
  //align-items: flex-end;
  //flex: 0 0 auto;
  //img {
  //  width: 100%;
  //}
  //@media (min-width: 1800px) {
  //  min-width: 200px;
  //  max-width: 250px;
  //}
  //
  //&.bigImg {
  //  width: 30%;
  //  min-width: 200px;
  //  max-width: 272px;
  //}
  position: relative;
  width: 70px;

  img {
    width: 70px;
    height: 70px;
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 1;
  }

  &.allowOverlap {
    overflow: visible;
  }
`;

export const RDTitleBlock = styled.div`
  display: flex;
  align-items: center;
  font-size: 16px;
  .bold {
    font-weight: 700;
  }
`;

export const RDTitleLabel = styled.div`
  box-shadow: 0 5px 10px 0 #00000033;
  border-radius: 25px;
  padding: 1px 8px;
  color: #ffffff;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 700;
  margin-left: 10px;
  &.popular {
    background: linear-gradient(103.55deg, #fdbc4b -5.18%, #db8d04 52.46%);
  }
  &.new {
    background: linear-gradient(105.63deg, #ff2d38 39.07%, #f0868c 96.81%);
  }
`;

export const RDBlockButton = styled.div`
  margin: 16px 0 10px 0;
  span {
    font-size: 14px;
    font-weight: 700;
    color: #ff2d38;
    cursor: pointer;
    @media (min-width: 1800px) {
      font-size: clamp(14px, 1vw, 20px);
    }
  }
`;

export const RDButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 49px;
`;
